module.exports = __webpack_public_path__ + "img/ic-prev.4e158c30.svg";